/**
 * @desc 布局管理
 * @author qsj qushijie@qfei.cn
 */
export default {
  与表单设计保持一致: 'With Form Design Page Synchronization',
  详情页设置: 'Details Page Settings',
  前台打开的数据详情页可选择以下任一种模式生效: 'The data details page that opens in the foreground can be selected to take effect in one of the following modes',
  详情可查看: 'Details View',
  使用说明: 'Usage Instructions',
  设置: 'Settings',
  提示: 'Tips',
  与标设计页同步逻辑: 'With Standard Design Page Synchronization Logic',
  与表单设计页保持同步: 'With Form Design Page Synchronization',
  '与表单设计页字段排布、分组配置保持同步': 'With Form Design Page Field Arrangement and Group Configuration Synchronization',
  自定义详情页: 'Custom Details Page',
  '在表单设计页字段排布、分组配置基础上进行自定义设置，并开放添加重复字段、页签等功能': 'Customize the details page based on the field arrangement and group configuration on the form design page, and open the function of adding duplicate fields, tabs, etc.',
  '字段的新增、删除会同步至详情页,移动不会同步至详情页': 'Fields added, deleted, or moved will be synchronized to the details page; moving will not be synchronized to the details page',
  分组的任何操作都不会同步至详情页: 'Any operation on the group will not be synchronized to the details page',
  '切换至与表单设计页保持同步后，对象数据的详情页将以此模式配置为准，且自定义详情页配置仍然会保存供后续使用，是否确认切换?': 'When you switch to synchronize with the form design page, the details page of the object data will be configured in this mode, and the custom details page configuration will still be saved for later use. Do you want to confirm the switch?',
  '切换至自定义详情页后，对象数据的详情页将以自定义详情页配置为准，是否确认切换？': 'When you switch to the custom details page, the details page of the object data will be configured in this mode, and the custom details page configuration will still be saved for later use. Do you want to confirm the switch?'
};
